import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import ProvidersList from "./ProvidersList";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import { Provider } from "../../../type/entities/provider-type";
import cn from "../../../utils/classNames";
import ProviderImportModal from "../components/ProviderImportModal";
import { HiOutlineTrash } from "react-icons/hi2";

const ProvidersListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [isOpenImportModal, setIsOpenImportModal] = useState(false);
    const [isOpenDeleteAllModal, setIsOpenDeleteAllModal] = useState(false);
    const [providerSelected, setProviderSelected] = useState<Provider | null>(null);
    const providersTableRefetchRef = useRef<(() => void) | null>(null);
    const defaultFilters = {};

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de proveedores' },
        { name: 'Proveedores', href: menuRoutes.providers.path },
    ];

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);
    const registerTableRefetch = useCallback((fn: () => void) => {
        providersTableRefetchRef.current = fn;
    }, []);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de proveedores" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                        {
                            userCan('delete_all', 'provider') &&
                            (
                                <Button
                                    color="danger"
                                    onClick={() => setIsOpenDeleteAllModal(true)}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    <HiOutlineTrash className="w-4 h-4" />
                                    <span className="ms-2">Eliminar todos los proveedores</span>
                                </Button>
                            )
                        }
                        {
                            userCan('create', 'provider') &&
                            (
                                <Button
                                    variant="outline"
                                    onClick={() => setIsOpenImportModal(true)}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Importar Excel
                                </Button>
                            )
                        }
                        {
                            userCan('create', 'provider') &&
                            (
                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setIsOpenFormDrawer(true)
                                        setProviderSelected(null)
                                    }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Crear proveedor
                                </Button>
                            )
                        }
                    </div>
                </PageHeader>
                <ProvidersList 
                    openFormDrawer={isOpenFormDrawer} 
                    setOpenFormDrawer={setIsOpenFormDrawer} 
                    providerSelected={providerSelected} 
                    setProviderSelected={setProviderSelected} 
                    openDeleteAllModal={isOpenDeleteAllModal}
                    setOpenDeleteAllModal={setIsOpenDeleteAllModal}
                    registerTableRefetch={registerTableRefetch}
                />
                <ProviderImportModal 
                    isOpen={isOpenImportModal} 
                    onClose={() => setIsOpenImportModal(false)} 
                    refetch={() => {
                        providersTableRefetchRef.current?.();
                    }} 
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default ProvidersListWrapper;
